interface KeyProps {
    label: string;
}

function Key({ label }: KeyProps) {
    return (
        <span className="key">{label}</span>
    );
}

export default Key;
